import { ProspectData } from '../_generated/client/model/prospectData';

export const mockProspectDataComplete = {
    id: '909dc508-ecdf-4001-b011-cde54b4d123c',
    prospectSchemaId: 'default-schema',
    createdDate: new Date('2022-01-03T12:49:34.989Z'),
    source: 'Invitation',
    coordinatorUserId: 'Admin',
    updatedDate: new Date('2022-01-06T12:49:34.989Z'),
    submittedDate: new Date('2021-12-06T12:49:34.989Z'),
    migration: null,
    status: ProspectData.StatusEnum.Submitted,
    businessName: 'Company ABC',
    stages: {
        'stage-schema-create-account': {
            fields: {
                'field-schema-first-name': {
                    fieldValue: 'John'
                },
                'field-schema-last-name': {
                    fieldValue: 'Doe'
                },
                'field-schema-email': {
                    fieldValue: 'johndoe@lsq.com'
                },
                'field-schema-mobile': {
                    fieldValue: '1234567891'
                },
                'field-schema-password1': {
                    fieldValue: ''
                },
                'field-schema-password2': {
                    fieldValue: ''
                }
            }
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '148498'
                }
            }
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '111111'
                }
            }
        },
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-name': {
                    fieldValue: 'Company ABC'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-tax-id': {
                    fieldValue: '123456789'
                },
                'field-schema-business-website': {
                    fieldValue: 'www.c-abc.com'
                },
                'field-schema-business-address-main': {
                    fieldValue: 'Address 1'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: 'Address 2'
                },
                'field-schema-business-city': {
                    fieldValue: 'Ny'
                },
                'field-schema-business-state': {
                    fieldValue: 'New York'
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            }
        },
        'stage-schema-documents': {
            fields: {
                'field-schema-document-field-1': {
                    fieldValue: [
                        {
                            documentId: 'field-schema-document-field-1',
                            documentNotes: 'Q1 2021',
                            fileName: 'sample.pdf',
                            uploadedDate: '2022-01-03T14:04:54.450Z'
                        }
                    ]
                },
                'field-schema-document-field-2': {
                    fieldValue: [
                        {
                            documentId: 'field-schema-document-field-2',
                            documentNotes: 'Q2 2021',
                            fileName: 'sample.pdf',
                            uploadedDate: '2022-01-03T14:04:54.450Z'
                        }
                    ]
                },
                'field-schema-document-field-3': {
                    fieldValue: [
                        {
                            documentId: 'field-schema-document-field-3',
                            documentNotes: 'Q1 2021',
                            fileName: 'sample.pdf',
                            uploadedDate: '2022-01-03T14:04:54.450Z'
                        }
                    ]
                },
                'field-schema-document-field-4': {
                    fieldValue: [
                        {
                            documentId: 'field-schema-document-field-4',
                            documentNotes: '2021',
                            fileName: 'sample.pdf',
                            uploadedDate: '2022-01-03T14:04:54.450Z'
                        }
                    ]
                },
                'field-schema-document-field-5': {
                    fieldValue: [
                        {
                            documentId: 'field-schema-document-field-5',
                            documentNotes: 'Q3 2021',
                            fileName: 'sample.pdf',
                            uploadedDate: '2022-01-03T14:04:54.450Z'
                        }
                    ]
                }
            }
        },
        'stage-schema-review-submit': {
            fields: []
        }
    }
};

export const mockPartialProspectData = {
    id: '909dc508-ecdf-4001-b011-cde54b4d123c',
    prospectSchemaId: 'default-schema',
    createdDate: new Date('2022-01-03T12:49:34.989Z'),
    source: 'Invitation',
    coordinatorUserId: 'Admin',
    updatedDate: new Date('2022-01-06T12:49:34.989Z'),
    submittedDate: new Date('2021-12-06T12:49:34.989Z'),
    migration: null,
    status: ProspectData.StatusEnum.Invited,
    businessName: 'Company ABC',
    token: '909dc508-ecdf-4001-b011-cde54b4d123d',
    stages: {
        'stage-schema-create-account': {
            fields: {
                'field-schema-first-name': {
                    fieldValue: 'John'
                },
                'field-schema-last-name': {
                    fieldValue: 'Doe'
                },
                'field-schema-email': {
                    fieldValue: 'johndoe@lsq.com'
                }
            }
        },
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-name': {
                    fieldValue: 'Company ABC'
                }
            }
        }
    }
};
//stage mocks
export const mockRegisteredProspectData = {
    statusCode: 200,
    body: {
        businessName: 'Company ABC',
        companyKey: '909dc508-ecdf-4001-b011-cde54b4d123c',
        coordinatorUserId: 'admin',
        createdDate: '2022-03-28T17:00:19.250Z',
        expirationDate: '2022-04-27T17:00:19.250Z',
        id: 'e99b5c76-5b12-47c3-a2ad-2009dc2afdd5',
        isDeleted: false,
        prospectSchemaId: 'prospect-schema-default-with-mfa',
        source: 'Invitation',
        stages: {
            'stage-schema-business-information': {
                fields: {
                    'field-schema-business-name': {
                        fieldValue: 'Company ABC'
                    }
                },
                isCompleted: false
            },
            'stage-schema-create-account': {
                fields: {
                    'field-schema-email': {
                        fieldValue: 'johndoe@lsq.com'
                    },
                    'field-schema-first-name': {
                        fieldValue: 'john'
                    },
                    'field-schema-last-name': {
                        fieldValue: 'Doe'
                    },
                    'field-schema-mobile': {
                        fieldValue: '9788384229'
                    }
                },
                isCompleted: true
            }
        },
        status: ProspectData.StatusEnum.Registered,
        token: 'cb92bff0-1976-4026-b0b0-d9f1d66f91a3',
        updatedDate: '2022-03-28T17:01:18.746Z'
    }
};
export const mockEmailConfirmedProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                }
            },
            isCompleted: false
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T21:41:31.857Z'
};
export const mockSMSConfirmedProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                }
            },
            isCompleted: false
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:05:50.331Z'
};
export const mockBusinessProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:13:53.976Z'
};
export const mockDocumentProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        },
        'stage-schema-documents': {
            fields: {
                'field-schema-document-field-1': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        },
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging-2.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging-2.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-2': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-income-statement.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-income-statement.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-3': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-balance-sheet.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-balance-sheet.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-4': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-customer-list.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-customer-list.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-5': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-articles.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-articles.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                }
            },
            isCompleted: true
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:46:11.689Z'
};
export const mockSubmitProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        },
        'stage-schema-documents': {
            fields: {
                'field-schema-document-field-1': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        },
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging-2.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging-2.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-2': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-income-statement.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-income-statement.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-3': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-balance-sheet.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-balance-sheet.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-4': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-customer-list.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-customer-list.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-5': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-articles.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-articles.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                }
            },
            isCompleted: true
        },
        'stage-schema-review-submit': {
            fields: {},
            isCompleted: true
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:46:11.689Z'
};
export const mockSubmittedProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        },
        'stage-schema-documents': {
            fields: {
                'field-schema-document-field-1': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        },
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging-2.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging-2.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-2': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-income-statement.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-income-statement.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-3': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-balance-sheet.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-balance-sheet.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-4': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-customer-list.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-customer-list.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-5': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-articles.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-articles.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                }
            },
            isCompleted: true
        },
        'stage-schema-review-submit': {
            fields: {},
            isCompleted: true
        }
    },
    status: 'Submitted',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:46:11.689Z'
};
//document mocks
export const mockDocumentArAging1ProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        },
        'stage-schema-documents': {
            fields: {
                'field-schema-document-field-1': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                }
            },
            isCompleted: false
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:46:11.689Z'
};
export const mockDocumentArAging2ProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        },
        'stage-schema-documents': {
            fields: {
                'field-schema-document-field-1': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        },
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging-2.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging-2.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                }
            },
            isCompleted: false
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:46:11.689Z'
};
export const mockDocumentIncomeStatementProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        },
        'stage-schema-documents': {
            fields: {
                'field-schema-document-field-1': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        },
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging-2.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging-2.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-2': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-income-statement.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-income-statement.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                }
            },
            isCompleted: false
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:46:11.689Z'
};
export const mockDocumentBalanceSheetProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        },
        'stage-schema-documents': {
            fields: {
                'field-schema-document-field-1': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        },
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging-2.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging-2.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-2': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-income-statement.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-income-statement.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-3': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-balance-sheet.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-balance-sheet.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                }
            },
            isCompleted: true
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:46:11.689Z'
};

export const mockDocumentDeleteBalanceSheetProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        },
        'stage-schema-documents': {
            fields: {
                'field-schema-document-field-1': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        },
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-ar-aging-2.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-ar-aging-2.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-2': {
                    fieldValue: [
                        {
                            documentId:
                                'b5bc6d35-42f9-4daf-a005-746c6dc2dee8/field-schema-document-field-1_1648593971_sample-income-statement.pdf',
                            documentNotes: 'test',
                            fileName: 'sample-income-statement.pdf',
                            uploadedDate: '2022-03-29T22:46:11.689473853Z'
                        }
                    ]
                },
                'field-schema-document-field-3': {}
            },
            isCompleted: false
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:46:11.689Z'
};

export const mockDocumentDeleteProspectData = {
    businessName: 'mockTest',
    companyKey: '3d5c83e9-d444-4787-a743-119a41d561df',
    coordinatorUserId: 'maguero@lsq.com',
    createdDate: '2022-03-29T21:14:58.680Z',
    expirationDate: '2022-04-28T21:14:58.680Z',
    id: 'b5bc6d35-42f9-4daf-a005-746c6dc2dee8',
    isDeleted: false,
    prospectSchemaId: 'prospect-schema-default-with-mfa',
    source: 'Invitation',
    stages: {
        'stage-schema-business-information': {
            fields: {
                'field-schema-business-address-main': {
                    fieldValue: 'test'
                },
                'field-schema-business-address-secondary': {
                    fieldValue: ''
                },
                'field-schema-business-city': {
                    fieldValue: 'test'
                },
                'field-schema-business-industry': {
                    fieldValue: 'Agency Services (Consulting, Creative, Marketing, Advertising)'
                },
                'field-schema-business-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-business-state': {
                    fieldValue: 'Alabama'
                },
                'field-schema-business-tax-id': {
                    fieldValue: ''
                },
                'field-schema-business-website': {
                    fieldValue: ''
                },
                'field-schema-business-zip': {
                    fieldValue: '12345'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account': {
            fields: {
                'field-schema-email': {
                    fieldValue: 'marlon4051+mockTest@gmail.com'
                },
                'field-schema-first-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-last-name': {
                    fieldValue: 'mockTest'
                },
                'field-schema-mobile': {
                    fieldValue: '9788384229'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-email-confirmation': {
            fields: {
                'field-schema-email-code': {
                    fieldValue: '709457'
                }
            },
            isCompleted: true
        },
        'stage-schema-create-account-two-factor': {
            fields: {
                'field-schema-sms-code': {
                    fieldValue: '484794'
                }
            },
            isCompleted: true
        },
        'stage-schema-documents': {
            fields: {},
            isCompleted: false
        }
    },
    status: 'Registered',
    submittedDate: '0001-01-01T00:00:00.000Z',
    token: 'ab0da09d-2905-47fa-ae0c-8d3942e91ae7',
    updatedDate: '2022-03-29T22:46:11.689Z'
};

export const mockProspectData = mockProspectDataComplete;
